import Super from './-resource';
import classic from 'ember-classic-decorator';

@classic
export default class SiteAppointmentsUpcoming extends Super {
  model() {
    return this._model({ hasPendingConfirmation: false });
  }
}
